import { render, staticRenderFns } from "./RelatedApps.vue?vue&type=template&id=38de708c&"
import script from "./RelatedApps.vue?vue&type=script&lang=js&"
export * from "./RelatedApps.vue?vue&type=script&lang=js&"
import style0 from "./RelatedApps.vue?vue&type=style&index=0&id=38de708c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports